// @flow
import { connect } from 'react-redux';
import ChooseNumber from './ChooseNumber';
import { goToNextActivationPage } from '../../../modules/SignUp';

import type { StateType } from '../../../modules/reducers';
import type { StateProps, DispatchProps } from './ChooseNumber';

const mapStateToProps = (state: StateType): StateProps => ({
  isActivationPath: true,
});

const mapDispatchToProps: DispatchProps = {
  goToNextPage: goToNextActivationPage,
};

export default connect(mapStateToProps, mapDispatchToProps)(ChooseNumber);
